import { render, staticRenderFns } from "./AdminOccupationSkillsTab.vue?vue&type=template&id=67d6d1e2"
import script from "./AdminOccupationSkillsTab.vue?vue&type=script&lang=js"
export * from "./AdminOccupationSkillsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d6d1e2')) {
      api.createRecord('67d6d1e2', component.options)
    } else {
      api.reload('67d6d1e2', component.options)
    }
    module.hot.accept("./AdminOccupationSkillsTab.vue?vue&type=template&id=67d6d1e2", function () {
      api.rerender('67d6d1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/occupation-skill/AdminOccupationSkillsTab.vue"
export default component.exports